/* istanbul ignore file */

import React from 'react';
import { connect } from 'react-redux';
import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import type { BreadcrumbLinkClickPayload } from '@noths/polaris-client-next-components';
import { Breadcrumbs } from '@noths/polaris-client-next-components';

import { selectBreadcrumbData } from 'src/components/molecules/Breadcrumbs/modules/selectors';
import type { BreadcrumbsContainerStateProps } from 'src/components/molecules/Breadcrumbs/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const mapStateToProps = (state: ReduxApplicationState): BreadcrumbsContainerStateProps => ({
  breadcrumbsLinks: selectBreadcrumbData(state),
});

const Container = ({ breadcrumbsLinks }: BreadcrumbsContainerStateProps) => {
  const onLinkClick = (
    e: React.MouseEvent | React.MouseEvent<HTMLAnchorElement>,
    { linkDepth }: BreadcrumbLinkClickPayload,
  ) => {
    return sendGALinkClickEvent(e, {
      event: 'custom_event',
      event_action: 'Link Click',
      event_category: 'Breadcrumb',
      event_label: `${linkDepth} Level(s) Up`,
      destination_URL: (e.currentTarget as HTMLAnchorElement).href,
    });
  };

  return <Breadcrumbs links={breadcrumbsLinks} onLinkClick={onLinkClick} />;
};

export const BreadcrumbContainer = connect(mapStateToProps)(Container);
